module.exports = "https://trybtryb-legacy.web.app/img/subscription.59b8bfe3.svg";